import { QuestionType } from "../../../api/main/models/codeOnly/QuestionType";
import { DeleteQuestionBase } from "../DeleteQuestionBase";

/**
 * Delete a questionnaire.
 */
export const DeleteQuestionnaire = () => (<DeleteQuestionBase defaultQuestionType={QuestionType.Questionnaire} />);
